module.exports = __webpack_public_path__ + "img/up.c40ae649.png";